import { Modal, ModalBody } from "reactstrap"
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"

const LoanDetailsModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  const data = [
    { field: "Loan ID", value: "#1234567" },
    { field: "Loan Type", value: "Short-term Loan" },
    { field: "Loan Amount", value: "$50,000" },
    { field: "Repayment Option", value: "Automatic Deduction" },
    { field: "Status", value: "Active" },
    { field: "Disbursement Date", value: "20/06/2024" },
    { field: "Next Payment Due", value: "05/08/2024" },
    { field: "Total Amount Paid", value: "$10,000" },
    { field: "Remaining Balance", value: "$40,000" },
  ]

  const columns = [
    { name: "Field", selector: (row) => row.field, grow: 1 },
    { name: "Information", selector: (row) => row.value, grow: 2 },
  ]

  const repaymentScheduleData = [
    { installment: 1, dueDate: '05/07/2024', amount: '$5,000', status: 'Paid' },
    { installment: 2, dueDate: '05/07/2024', amount: '$5,000', status: 'Due' },
    { installment: 3, dueDate: '05/07/2024', amount: '$5,000', status: 'Due' },
    { installment: 4, dueDate: '05/07/2024', amount: '$5,000', status: 'Due' },
    { installment: 5, dueDate: '05/07/2024', amount: '$5,000', status: 'Due' },
  ]

  const repaymentScheduleColumns = [
    { name: 'Installment', selector: row => row.installment },
    { name: 'Due date', selector: row => row.dueDate },
    { name: '', selector: row => row.amount },
    { name: '', selector: row => row.status },
  ]

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <div className="my-3 fw-medium">Detailed Loan View</div>

          <div className="fw-medium">Loan Details:</div>
          <DatatableComponent columns={columns} data={data} type={"black-bordered"} />

          <div className="fw-medium my-3">Repayment Schedule:</div>
          <DatatableComponent columns={repaymentScheduleColumns} data={repaymentScheduleData} type={"black-bordered"} />

        </ModalBody>
      </Modal>
    </div>
  )
}

export default LoanDetailsModal
